// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_1jnjYbuCD_DL","item":"_1xFsotnDQd9w","item_active":"_1VWbXi5qtWb1"};